import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Footer from 'components/Footer';

const Page = ({ children, background, transparent, banner }) => {
  return (
    <Root>
      <Background
        style={{
          backgroundImage: `url(${background})`,
        }}
      />
      <Fragment>{banner}</Fragment>
      <Content transparent={transparent}>{children}</Content>
      <Footer />
    </Root>
  );
};

Page.propTypes = {
  background: PropTypes.any,
  transparent: PropTypes.bool,
};

Page.defaultProps = {
  background: '',
  transparent: false,
};

const Root = styled.main``;

const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -1;
  background-size: cover;
  background-position: 50% 50%;
`;

const Content = styled.div`
  background: ${props => (props.transparent ? 'transparent' : '#fff')};
`;

export default Page;



// WEBPACK FOOTER //
// ./src/components/Page.js